import * as R from 'ramda'

let compareObjects: (objA:any, objB:any, objAName:string, objBName:string) => {equal: boolean, message?: string}

compareObjects = (objA, objB, objAName, objBName) => {
    

    if (objA == null && objB == null) {
        return {equal: true}
    }

    if (objA == null && objB != null) {
            return {equal: false, message: `${objAName} null <-> ${objBName} nao null`}
    }

    if (objB == null && objA != null) {
        return {equal: false, message:`${objAName} not null <-> ${objBName} null`}
    }


    if (typeof(objA) != typeof(objB)) {
        return {equal: false, message: `typeof(${objAName}) != typeof(${objBName})`}
    }

    if (Array.isArray(objA) && !Array.isArray(objB)) {
            return {equal: false, message: `${objAName} array <-> ${objBName} nao array`}
    }

    if (Array.isArray(objB) && !Array.isArray(objA)) {
        return {equal: false, message: `${objAName} nao array <-> ${objBName} array`}
    }

    if (R.includes(typeof(objB),['number','string','boolean'])) {
        return {equal: objA == objB, message: objA == objB ? null : `${objAName} [${objA}] != ${objBName} [${objB}]`}
    }

    if (Array.isArray(objA) && Array.isArray(objB)) {
        

        if ((objA as Array<any>).length != (objB as Array<any>).length) {
            return {equal: false, message: `${objAName} length != ${objBName} length`}
        }
        
        const compareMap = R.map(([el1, el2]) => compareObjects(el1,el2, `el ${objAName}`, `el ${objBName}`),R.zip(objA, objB))
        return {
            equal: R.all(r => r.equal, compareMap), 
            message: R.all(r => r.equal, compareMap) ? undefined : R.find(r => r.equal == false,compareMap).message
        }
    }

    const isNullOrUndefined = v => v === null || v === undefined
    const isNotNullOrUndefined = v => !isNullOrUndefined(v)

    const objAWithoutUndefined = R.pickBy(isNotNullOrUndefined,objA)
    const objBWithoutUndefined = R.pickBy(isNotNullOrUndefined, objB)

    if (Object.keys(objAWithoutUndefined).length != Object.keys(objBWithoutUndefined).length) {
        const diff = R.difference(Object.keys(objAWithoutUndefined), Object.keys(objBWithoutUndefined))

        return {equal: false, message: `${objAName} ${Object.keys(objAWithoutUndefined).length} propriedades <-> ${objBName} ${Object.keys(objBWithoutUndefined).length} [${diff.join(',')}]`}
    }

    const stringCompare = (s1:string,s2:string) => s1.localeCompare(s2)

    const keys = R.zip(R.sort(stringCompare, Object.keys(objAWithoutUndefined)),R.sort(stringCompare, Object.keys(objBWithoutUndefined)))

    const compareMap = R.map(([k1,k2]) => compareObjects(objAWithoutUndefined[k1], objBWithoutUndefined[k2], k1, k2),keys)

    return {
        equal: R.all(r => r.equal,compareMap), 
        message: R.all(r => r.equal,compareMap) ? undefined : R.find(r => r.equal == false, compareMap).message
    }
}

export {compareObjects}